import React from 'react'

 const Footer = () => {
  return (

    <>
    <footer className='f1'>
        <div className='div1'>
            <h1 className='.hh1'>SuperHeroes</h1>
            <p className='p'>@all rights are owned by ayush&CO.</p>
        </div>

        <div className='div1'>
            <h5 className='h5' >follow us</h5>
            
            <a className='a' href='https://www.youtube.com/channel/UCyPKrf4eZ0MkEpGG9PJnKpg'target={"_blank"}>Youtube</a>
            <a className='a' href='https://instagram.com/thecanvasai?igshid=YmMyMTA2M2Y='target={"_blank"}>instagram</a>
            <a className='a' href='https://github.com/ayush0534'target={"_blank"}>Github</a>
            
        </div>
    </footer>
    </>
  );
};

export default Footer;